import * as Preact from "preact"

import ProgressReport from "@fae/source/data/games/school/views/ProgressReport.jsx"

import "@fae/source/data/games/school/views/index.less"

export default function ProgressReportsHUD({stage}) {
    return (
        <div class="ProgressReportsHUD">
            <ProgressReport unit={stage.units.nerd}/>
            <ProgressReport unit={stage.units.punk}/>
            <ProgressReport unit={stage.units.goth}/>
        </div>
    )
}
